import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/home'
import mine from '@/pages/mine/mine'
import payment from '@/pages/payment/payment'
import MyOrder from '@/pages/mine/MyOrder'
import Voice from '@/pages/home/Voice'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  // hisoty模式需要服务器做一些配置
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/MyOrder',
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/Voice',
      name: 'Voice',
      component: Voice,
      // meta: {
      //   requiresAuth: true
      // }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js